module.exports = __webpack_public_path__ + "img/BG.5029c70c.svg";